const FirebaseConfig = {
  apiKey: "AIzaSyB2WL1bXBZfrES33ZMlurMaJRG5gKNTZdA",
  authDomain: "tunisms-1ead9.firebaseapp.com",
  projectId: "tunisms-1ead9",
  storageBucket: "tunisms-1ead9.appspot.com",
  messagingSenderId: "425123461407",
  appId: "1:425123461407:web:b5012e558be7c0f807982a",
  measurementId: "G-J1W83QT74D"
};

export default FirebaseConfig

